import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Input } from 'components'
import styles from './RangeBuilderController.scss';

const RangeBuilderController = ({
    labelText,
    isDisabled,
    value,
    handleChange
}) =>
    <FormControl className={styles.container}>
        <div className={styles.label}>{ labelText }</div>
        <Input
            className={styles.input}
            type='number'
            disabled={isDisabled}
            value={value}
            onChange={handleChange}
        />
    </FormControl>;

RangeBuilderController.propTypes = {
    labelText: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    isDisabled: PropTypes.bool
};

RangeBuilderController.defaultProps = {
    labelText: '',
    value: '',
    isDisabled: false
};

export default RangeBuilderController;
